import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/register')({
  component: () => null, // Never renders
  loader: () => {
    throw redirect({ to: '/$locale/sign-up', params: { locale: 'en' } })
  },
})
